export const MyMissionsStatusFilter = {
  All: 'all',
  Ongoing: 'ongoing',
  InValidation: 'in-validation',
  Approved: 'approved',
} as const;

export type MyMissionsStatusFilter = (typeof MyMissionsStatusFilter)[keyof typeof MyMissionsStatusFilter];

export const filterMissionBlocksByStatus = <TBlock extends { status?: number }>(
  missionBlocks: readonly TBlock[],
  includedStatuses?: readonly number[],
): TBlock[] => {
  if (!includedStatuses) {
    return [...missionBlocks];
  }

  const includedStatusSet = new Set(includedStatuses);

  return missionBlocks.filter((missionBlock) => missionBlock.status !== undefined && includedStatusSet.has(missionBlock.status));
};
